import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { UserPicker } from 'src/common';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { useActiveUsers } from 'src/models/users/hooks';
import { trackTendersFilterAssigned } from 'src/segment/events';

const FilterAssigned: FC = () => {
  const { t } = useTranslation();
  const [{ vars, eventSource }, updateVars] = useApiTenders();
  const users = useActiveUsers();

  const selectedUsers = useMemo(() => vars.assignedTo ?? [], [vars.assignedTo]);
  const onChangeAssigned = useCallback(
    (assignedTo: string, checked?: boolean) => {
      const previousValue = selectedUsers ?? [];
      const currentValue = checked ? [...previousValue, assignedTo] : previousValue.filter(user => user !== assignedTo);
      updateVars({ assignedTo: currentValue });
      trackTendersFilterAssigned(eventSource);
    },
    [eventSource, selectedUsers, updateVars]
  );

  return (
    <UserPicker
      label={t('Common.assignedTo')}
      users={users}
      onSelect={onChangeAssigned}
      selected={selectedUsers}
      buttonClassName={styles.button}
      userPickerType={'multiple'}
      button
    />
  );
};

export default FilterAssigned;
